import React from 'react'
import { Box, Card, CardProps } from '@mui/material'

/* */
interface ColoredHeaderProps extends CardProps {
  header: string
}

const ColoredHeaderCard = (props: ColoredHeaderProps) => {
  const { children, header } = props
  return (
    <>
      <Card
        sx={{
          borderRadius: '16px',
          width: 'clamp(420px,20vw,420px)'
        }}
      >
        <Box
          sx={{
            textTransform: 'uppercase',
            background:
              'linear-gradient(91.41deg, rgba(103, 209, 221, 0.85) 0.14%, rgba(223, 70, 245, 0.85) 100%)',
            color: 'white',
            padding: '16px 24px'
          }}
        >
          {header}
        </Box>
        <Box sx={{ padding: '24px 32px' }} {...props}>
          {children}
        </Box>
      </Card>
    </>
  )
}

export default ColoredHeaderCard
